import { get, post, patch, put, del } from './axios'

const { items, itemDetail, selectVehicle, search } = require('./query')

export const getItems = (data = {}) => post('/api/graphql/', Object.assign(data, items()))
export const getItemDetail = (data = {}) => post('/api/graphql/', Object.assign(data, itemDetail()))
export const getVehicle = (data = {}) => post('/api/graphql/', Object.assign(data, selectVehicle()))
export const getSearch = (data = {}) => post('/api/graphql/', Object.assign(data, search()))


// WEBPACK FOOTER //
// ./src/http/api.js